import { processRequest } from "@api/config";
import { galleryAPI } from "@api/gallery";
import type { IGalleryItemsParams } from "@api/gallery";

import { useAuthQuery } from "@lib/queryClient";

import { API_PREFIXES, QUERY_KEYS } from "@configs/api";

const DEFAULT_QUERY_PARAMS = {
	page: 1,
	quantity: 1,
};

export const useVrVideoHistoryQuery = (params: IGalleryItemsParams | null) =>
	useAuthQuery({
		queryKey: [QUERY_KEYS.VR_VIDEO_HISTORY, params],
		queryFn: async () => {
			const data = await processRequest({
				prefix: API_PREFIXES.GET_VR_VIDEO_HISTORY,
				request: (token) => galleryAPI.getItemsAsync({ token, params: params ?? DEFAULT_QUERY_PARAMS }),
			});
			return data;
		},
	});
